import React from "react";
import PropTypes from 'prop-types';

var CarouselArrow = function CarouselArrow(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '16' : _ref$height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 16' : _ref$viewBox,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#1D2327' : _ref$fill,
      direction = _ref.direction;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, direction === 'prev' ? /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64936 1.23866L4.02104 6.76078L20.6582 6.86698L20.6228 8.49529L3.95024 8.53069L9.61396 14.1236L8.41042 15.3271L0.658207 7.68113L8.44582 -0.000277099L9.64936 1.23866Z",
    fill: fill
  }) : /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0088 1.23866L16.6372 6.76078L-3.69806e-07 6.86698L0.0353979 8.49529L16.708 8.53069L11.0442 14.1236L12.2478 15.3271L20 7.68113L12.2124 -0.000277099L11.0088 1.23866Z",
    fill: fill
  }));
};

CarouselArrow.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  viewBox: PropTypes.string,
  direction: PropTypes.string
};
export default CarouselArrow;